var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center mx-auto"},[_c('div',{staticClass:"text-gray-300 text-sm"},[_vm._v("Carregando")]),_c('div',{staticClass:"text-gray-700 text-2xl"},[_vm._v("Revele seus momentos")])])])
}]

export { render, staticRenderFns }